'use client';

import NextLink from 'next/link';
import type { LinkProps as NextLinkProps } from 'next/link';
import type { AnchorHTMLAttributes, ReactNode } from 'react';

type LinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof NextLinkProps> &
  NextLinkProps & {
    children?: ReactNode;
  };

/**
 * Wrapper around next/link with prefetch disabled by default.
 * News pages have 50+ article links visible at once — default viewport-based
 * prefetching fires an _rsc request for each, flooding the server.
 * Pass prefetch={true} explicitly on high-priority links (e.g., home logo).
 */
export default function Link({ prefetch = false, ...props }: LinkProps) {
  return <NextLink prefetch={prefetch} {...props} />;
}
